module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAAAXNSR0IArs4c6QAAAP1JREFUOE+NkD1OQkEUhc8ZglbURKAgsSXKBvxJ7NgBjYkdugUSjGxCaKCk0cKamEBo6AjGWFkKxg2YCDLHQIAw897Lc6qZufN9c+8hAEzOil1AueV+u0Qr6M5Qh7SJp4PB6M2pA+Aall9Yn38tFjcGpmSsqfoCD9aXxA6pMsB0nMCBSV1neuPG9Py4IvF+p5vQDtyfpWeANUB1kBfeKAFB3Mx+FI5gA7cAXEWE5l4Ls7l+8kmz11zBAsznabEt4jJOYKCahKysfVjB/xfwlrIZcfGY7b92t3C8wAWX7x04WhAEQ+GgIByMhDeCj5NCIfG9/25T86Nc72Xoh/kHLuScJPNtWQIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/image1/biaoqian1.png
// module id = pkxA
// module chunks = 34